import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { LocalStorageService } from "src/app/shared/services/core/storage.service";
import { JwtService } from "../../../../services/core/jwt.service";
@Component({
  selector: "app-my-account",
  templateUrl: "./my-account.component.html",
  styleUrls: ["./my-account.component.scss"],
})
export class MyAccountComponent implements OnInit {
  public userName: string;
  public profileImg: "assets/images/dashboard/profile.jpg";
  role: string | null;
  constructor(
    public router: Router,
    private store: LocalStorageService,
    private token: JwtService
  ) {
    this.userName = localStorage.getItem("username");
    // if (JSON.parse(localStorage.getItem("user"))) {
    // } else {
    // }
  }

  ngOnInit() {
    this.role = this.token.getRole();
  }

  logoutFunc() {
    this.store.remove("access_token");
    this.store.remove("role");
    this.store.remove("stationCodes");
    this.router.navigateByUrl("auth/login");
  }

  changePassword() {
    this.router.navigateByUrl("change-password");
  }
}
